import type { AccountDetailPayload, AccountMetricView } from '../account-detail.model';
import { formatAccountBalanceExact, formatAccountDate } from '../accounts-display';

function isDeclined(status: string): boolean {
  return status.trim().toLowerCase() === 'declined';
}

function formatApr(apr: number | null | undefined): string {
  if (apr === null || apr === undefined || !Number.isFinite(apr)) {
    return 'n/a';
  }
  return `${apr}%`;
}

function formatTerm(term: number | null | undefined): string {
  if (term === null || term === undefined || !Number.isFinite(term)) {
    return 'n/a';
  }
  return `${term} months`;
}

export function mapLoanSummary(payload: AccountDetailPayload): AccountMetricView[] {
  const declined = isDeclined(payload.status);
  const closed = payload.status.trim().toLowerCase() === 'closed';
  const dateLabel = declined ? 'Decision received' : 'Approval date';
  const dateValue = formatAccountDate(
    declined ? payload.statusUpdatedDate : payload.approvalDate
  );
  const money = declined ? 'n/a' : null;
  const metrics: AccountMetricView[] = [
    { label: dateLabel, value: dateValue },
    { label: 'Loan amount', value: money ?? formatAccountBalanceExact(payload.amount) },
    { label: 'APR', value: money ?? formatApr(payload.apr) },
    { label: 'Term', value: money ?? formatTerm(payload.loanTerm) },
    {
      label: 'Loan balance',
      value: money ?? formatAccountBalanceExact(payload.balance),
    },
  ];
  if (payload.lastModifiedDate) {
    metrics.push({ label: 'Last updated', value: formatAccountDate(payload.lastModifiedDate) });
  }
  if (closed && payload.statusUpdatedDate) {
    metrics.push({
      label: 'Closed date',
      value: formatAccountDate(payload.statusUpdatedDate),
    });
  }
  return metrics;
}
